import * as yup from "yup";

// var passwordRules =
//   /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*()_+])[A-Za-z\d][A-Za-z\d!@#$%^&*()_+]{5,}$/;

// export const loginSchema = yup.object().shape({
//   email: yup.string().email("Please enter a valid email").required("Required"),
//   password: yup.string().required("Required"),
// });

export const loginSchema = yup.object().shape({
  //email: yup.string().email("Please enter a valid email").required("Required"),
  password: yup.string().required(),
});

// export const registrationSchema = yup.object().shape({
//   name: yup.string().required("Required"),
//   email: yup.string().email("Please enter a valid email").required("Required"),
//   mobileNo: yup.number().positive().integer().min(9).required("Required"),
//   password: yup
//     .string()
//     .min(5)
//     .matches(passwordRules, { message: "Please create a stronger password" })
//     .required("Required"),
//   confirmPassword: yup
//     .string()
//     .oneOf([yup.ref("password"), null], "Passwords must match")
//     .required("Required"),
// });
